import { SidebarMenuState } from "../interfaces";
import { createSlice } from "@reduxjs/toolkit";

const initialState: SidebarMenuState = {
    isOpen: false
}

export const sidebarMenuSlice = createSlice({
    name: 'sidebarMenu',
    initialState,
    reducers: {
        toggleSideBarMenu: (state) => {
            state.isOpen = !state.isOpen
        },
    }
})

export default sidebarMenuSlice.reducer;
